import { Checkbox, Label } from '@web/ui/core';

export function PremisesField({
  id,
  label,
  children,
}: Readonly<{ id: string; label: string; children: React.ReactNode }>): React.JSX.Element {
  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={id}>{label}</Label>
      {children}
    </div>
  );
}

/** Checkbox com o rótulo visível ao lado (o átomo só o leva como nome acessível). */
export function PremisesCheck(
  props: Readonly<{
    label: string;
    checked: boolean;
    disabled: boolean;
    onChange: (checked: boolean) => void;
  }>,
): React.JSX.Element {
  return (
    <label className="flex h-10 items-center gap-2 text-meta text-foreground">
      <Checkbox {...props} />
      <span>{props.label}</span>
    </label>
  );
}
